module.exports = __webpack_public_path__ + "static/procliq_logo_white-2b4841518cd52a19b5d4431afd166f3f.svg";